module.exports = __webpack_public_path__ + "static/media/creales_harinadetrigo.cfdeda19.png";